var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.38,
    height: 28.38,
    viewBox: "0 0 28.38 28.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2861",
    "data-name": "Groupe 2861",
    transform: "translate(0 0)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1727",
    "data-name": "Trac\\xE9 1727",
    d: "M-153.7,261.329a3.881,3.881,0,0,0-3.881,3.881,3.881,3.881,0,0,0,3.881,3.881,3.888,3.888,0,0,0,3.881-3.881A3.881,3.881,0,0,0-153.7,261.329Z",
    transform: "translate(167.897 -251.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1728",
    "data-name": "Trac\\xE9 1728",
    d: "M-211.761,270.428a2.8,2.8,0,0,0-2.8-2.8,2.8,2.8,0,0,0-2.795,2.8,2.8,2.8,0,0,0,2.8,2.795h0A2.807,2.807,0,0,0-211.761,270.428Z",
    transform: "translate(217.357 -256.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1729",
    "data-name": "Trac\\xE9 1729",
    d: "M-82.517,267.6a2.8,2.8,0,0,0-2.8,2.8,2.8,2.8,0,0,0,2.8,2.8,2.8,2.8,0,0,0,2.8-2.8h0A2.807,2.807,0,0,0-82.517,267.6Z",
    transform: "translate(108.097 -256.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1730",
    "data-name": "Trac\\xE9 1730",
    d: "M-148.5,333.649a2.8,2.8,0,0,0-2.8,2.8,2.8,2.8,0,0,0,2.8,2.795,2.8,2.8,0,0,0,2.795-2.8h0A2.807,2.807,0,0,0-148.5,333.649Z",
    transform: "translate(162.688 -310.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1731",
    "data-name": "Trac\\xE9 1731",
    d: "M-148.527,207.168a2.8,2.8,0,0,0,2.794-2.8,2.8,2.8,0,0,0-2.8-2.794,2.8,2.8,0,0,0-2.794,2.8A2.807,2.807,0,0,0-148.527,207.168Z",
    transform: "translate(162.719 -201.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1732",
    "data-name": "Trac\\xE9 1732",
    d: "M-191.115,313.011a2.807,2.807,0,0,0-3.958,0,2.8,2.8,0,0,0,0,3.956l0,0a2.8,2.8,0,0,0,3.956,0l0,0a2.8,2.8,0,0,0,0-3.956Z",
    transform: "translate(199.596 -293.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1733",
    "data-name": "Trac\\xE9 1733",
    d: "M-105.926,227.808a2.807,2.807,0,0,0,3.958,0,2.8,2.8,0,0,0,0-3.956l0,0a2.8,2.8,0,0,0-3.956,0l0,0a2.8,2.8,0,0,0,0,3.956Z",
    transform: "translate(125.827 -219.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1734",
    "data-name": "Trac\\xE9 1734",
    d: "M-101.974,313.011a2.807,2.807,0,0,0-3.958,0,2.8,2.8,0,0,0,0,3.956l0,0a2.8,2.8,0,0,0,3.956,0l0,0a2.8,2.8,0,0,0,0-3.956Z",
    transform: "translate(125.833 -293.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1735",
    "data-name": "Trac\\xE9 1735",
    d: "M-191.115,223.85a2.8,2.8,0,0,0-3.956,0l0,0a2.8,2.8,0,0,0,0,3.956l0,0a2.807,2.807,0,0,0,3.958,0,2.8,2.8,0,0,0,0-3.956Z",
    transform: "translate(199.596 -219.329)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworksIcon);
export default __webpack_public_path__ + "static/media/networksIcon.955a203bdf3b6059f991a67ea3b293b8.svg";
export { ForwardRef as ReactComponent };